export default __webpack_public_path__ + "static/media/money_loss.edf61121.jpg";